import NotLoggedMiddleware from "../../middlewares/NotLoggedMiddleware";
import AuthRegisterView from "../../views/auth/register";
import AuthLoginView from "../../views/auth/login";
import AuthPasswordRecoverView from "../../views/auth/password/recover";
import AuthPasswordResetView from "../../views/auth/password/reset";
import EmailNonVerifiedMiddleware from "../../middlewares/EmailNonVerifiedMiddleware";
import LoggedMiddleware from "../../middlewares/LoggedMiddleware";
import AuthEmailVerifyView from "../../views/auth/email/verify";
import AuthOnboardView from "../../views/auth/onboard";
import EmailVerifiedMiddleware from "../../middlewares/EmailVerifiedMiddleware";
import NoCompanyMiddleware from "../../middlewares/NoCompanyMiddleware";
import AuthLandingView from "../../views/auth/landing";
import InvitationMiddleware from "../../middlewares/InvitationMiddleware";
import AcceptInvitation from "../../views/auth/invitation";

export default [
    {
        name: 'Auth Login',
        layout: '/auth',
        path: '/login',
        component: AuthLoginView,
        middlewares: [NotLoggedMiddleware],
    },
    {
        name: 'Auth Register',
        layout: '/auth',
        path: '/register',
        component: AuthRegisterView,
        middlewares: [NotLoggedMiddleware],
    },
    {
        name: 'Auth Password Recover',
        layout: '/auth',
        path: '/password/recover',
        component: AuthPasswordRecoverView,
        middlewares: [NotLoggedMiddleware],
    },
    {
        name: 'Auth Password Reset',
        layout: '/auth',
        path: '/password/reset',
        component: AuthPasswordResetView,
        middlewares: [NotLoggedMiddleware],
    },
    {
        name: 'Email Verification',
        layout: '/auth',
        path: '/email/verify',
        component: AuthEmailVerifyView,
        middlewares: [LoggedMiddleware, EmailNonVerifiedMiddleware]
    },
    {
        name: 'Email Verification',
        layout: '/auth',
        path: '/onboard',
        component: AuthOnboardView,
        middlewares: [InvitationMiddleware, LoggedMiddleware, EmailVerifiedMiddleware, NoCompanyMiddleware]
    },
    {
        name: 'Auth Landing',
        layout: '/auth',
        path: '/',
        component: AuthLandingView,
        middlewares: [NotLoggedMiddleware, InvitationMiddleware]
    },
    {
        name: 'Accept Invitation',
        layout: '/auth',
        path: '/accept-invitation',
        component: AcceptInvitation,
        middlewares: [InvitationMiddleware, LoggedMiddleware, EmailVerifiedMiddleware]
    },
    {
        name: 'Accept Invitation Token',
        layout: '/auth',
        path: '/accept-invitation/:token',
        component: AcceptInvitation,
        middlewares: [InvitationMiddleware, LoggedMiddleware, EmailVerifiedMiddleware]
    },
];
